module.exports = "/_next/static/images/Cover-1cbc63bbceda56b4915f175e5955daca.webp";